import { FC, ReactElement } from "react";
import { Box } from "@material-ui/core";

interface QueryParamFilterControlProps {
  filters: ReactElement[];
}

const FilterControls: FC<QueryParamFilterControlProps> = ({ filters }) => (
  <Box marginBottom={4} data-testid="filter-controls">
    {filters.map((filter, index) => (
      <Box mb={3} key={index}>
        {filter}
      </Box>
    ))}
  </Box>
);

export default FilterControls;
